import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { IApp } from '@core/models/app.interfaces';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Table, TableModule } from 'primeng/table';
import { ITableViewConfig } from '../../models/table-view.model';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

export const itemsPerPage = [10, 50, 100, 250, 500];

@Component({
  selector: 'app-editable-table-view',
  templateUrl: './editable-table-view.component.html',
  styleUrls: ['./editable-table-view.component.scss'],
  imports: [TableModule, CommonModule, TranslateModule, FormsModule]
})
export class EditableTableViewComponent implements OnInit {

  @Input() data: any;
  @Input() config: ITableViewConfig;
  @Input() firstItemIndex = 0;
  @Output() paginationChanged = new EventEmitter<IApp.IPagination>();
  @Output() rowEdit = new EventEmitter<any>();
  @ViewChild('tableContainer', {static: true}) tableContainer: ElementRef;
  @ViewChild('dT', {static: false}) table: Table;

  itemsPerPage = itemsPerPage;

  tableDates = [];

  constructor(
    private translate: TranslateService,
  ) { }

  ngOnInit() {
    if (!this.config) {
      throw new Error('No configuration specified for table component');
    }
    if (this.config.paginator && (this.data && !this.data['content'])) {
      throw new Error('Data object is not IPageable type');
    }
    if (this.config.paginator && !this.config.rowsPerPage) {
      throw new Error('Please specify rowsPerPage in table config');
    }

    this.paginatorText();

    setTimeout(() => window.dispatchEvent(new Event('resize')), 500);
  }

  onPaginationChanged($event: any) {
    const page = $event.first /  ($event.rows || this.config.rowsPerPage || this.itemsPerPage[0]);
    const size = $event.rows || this.config.rowsPerPage;
    let sort;
    let dir;
    if ($event.sortField) {
      sort = $event.sortField;
      dir = $event.sortOrder < 0 ? 'DESC' : 'ASC';
    }
    this.paginationChanged.emit({ sort, dir, page, size } as IApp.IPagination);

    this.paginatorText();
  }

  paginatorText() {
    if (this.config.paginator) {
      setTimeout(() => {
        const paginator: HTMLElement = document
          .getElementsByClassName('p-dropdown-trigger-icon pi pi-chevron-down')[0].parentElement as HTMLElement;
        if (paginator.childElementCount === 1) {
          const itemPerPage = document.createElement('div');
          itemPerPage.innerText =  this.translate.instant('COMMON.table.itemsPerPageText');
          itemPerPage.setAttribute('style', 'width: 10rem;margin-left: 20px;');
          paginator.append(itemPerPage);
        }
      }, 100);
    }
  }

  getDefaultDate(modelDate) {
    return new Date(modelDate);
  }

  updateDate(value, rowDate) {
    this.tableDates[rowDate] = value;
  }

  getDate(modelDate) {
    return new Date(modelDate);
  }

  onRowEditInit(rowData) {
    this.rowEdit.emit(rowData);
  }

  @HostListener('window:resize', ['$event'])
  resizeTableScrollArea() {
    if (this.table && !this.config.paginator) {
      setTimeout(() => {
        const tableEl = this.table.getBlockableElement();
        const tableScrollableBody: Partial<HTMLElement> = tableEl.getElementsByClassName('p-datatable-scrollable-body')[0];
        const tableContainerHeight = this.tableContainer.nativeElement.clientHeight;
        tableScrollableBody.style.maxHeight = `${ tableContainerHeight - 46 }px`;
      }, 0);
    }
  }

}
